import React, { useEffect, useState } from 'react';
import Header from './components/header/header';
import Tabs from './components/tabs/tabs';
import Form from './components/form/form';
import TodoList from './components/todoList/todoList';

function App() {
  //State
  const [inputText, setInputText] = useState('');
  const [todos, setTodos] = useState([]);
  const [status, setStatus] = useState('All');
  const [filteredTodos, setFilteredTodos] = useState([]);
  const [searchTodo, setSearchTodo] = useState('');
  //Use effect
  useEffect(() => {
    getLocalTodos();
  }, []);

  useEffect(() => {
    filterhandler();
    saveLocalTodos();
  }, [todos, status]);

  //Functions
  const filterhandler = () => {
    switch (status) {
      case 'Done':
        setFilteredTodos(todos.filter((todo) => todo.completed === true));
        break;
      case 'Active':
        setFilteredTodos(todos.filter((todo) => todo.completed === false));
        break;
      default:
        setFilteredTodos(todos);
        break;
    }
  };

  const searchHandler = filteredTodos.filter((todo) => {
    return todo.text.toLowerCase().includes(searchTodo.toLowerCase());
  });

  // Save to Local
  const saveLocalTodos = () => {
    localStorage.setItem('todos', JSON.stringify(todos));
  };
  const getLocalTodos = () => {
    if (localStorage.getItem('todos') === null) {
      localStorage.setItem('todos', JSON.stringify([]));
    } else {
      let todoLocal = JSON.parse(localStorage.getItem('todos'));
      setTodos(todoLocal);
    }
  };

  return (
    <div className='App'>
      <Header setSearchTodo={setSearchTodo} />
      <section>
        <div className='container'>
          <Tabs setStatus={setStatus} status={status} />
          <Form
            inputText={inputText}
            todos={todos}
            setTodos={setTodos}
            setInputText={setInputText}
          />
          <TodoList
            setTodos={setTodos}
            todos={todos}
            searchHandler={searchHandler}
          />
        </div>
      </section>
    </div>
  );
}

export default App;
